/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {AdnApiClientService} from '../../common/controller/adn-api-client.service';
import {
  SignalAdminResourceApiBase,
  SignalAdminResourceModel,
  SignalAdminResourcePage
} from '../../common/controller/signal-admin-resource-api';

export interface ExternalDemandSourceModel extends SignalAdminResourceModel {
  [key: string]: any;
}

@Injectable({providedIn: 'root'})
export class ExternalDemandSourceApiService extends SignalAdminResourceApiBase<ExternalDemandSourceModel> {
  constructor(client: AdnApiClientService) {
    super(client, 'externaldemandsources');
  }

  listOptions(params: Record<string, any> = {}): Observable<SignalAdminResourcePage<ExternalDemandSourceModel>> {
    return this.client.request<SignalAdminResourcePage<ExternalDemandSourceModel>>({
      method: 'GET',
      url: this.resourceUri('externaldemandsources'),
      params: {
        includeHidden: false,
        includeActive: true,
        includeInactive: false,
        orderBy: 'name',
        pageSize: 1001,
        ...params
      }
    });
  }
}
